export default {"src":"/_next/static/media/gm.c8ccdd0a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};